import { create } from 'zustand';

export interface CvStoreState {
  currentCvId: string | null;
  isDirty: boolean;
  lastSavedAt: string | null;
  setCurrentCvId: (id: string | null) => void;
  markDirty: () => void;
  markSaved: () => void;
  reset: () => void;
}

const initialState = {
  currentCvId: null,
  isDirty: false,
  lastSavedAt: null,
} as const;

export const useCvStore = create<CvStoreState>((set) => ({
  ...initialState,
  setCurrentCvId: (currentCvId) => set({ currentCvId }),
  markDirty: () => set({ isDirty: true }),
  markSaved: () => set({ isDirty: false, lastSavedAt: new Date().toISOString() }),
  reset: () => set({ ...initialState }),
}));
